import React, { Suspense } from "react";
import { Navigate } from "react-router-dom";
import PerfilEgresoCohorte from "./sgc/PerfilEgresoCohorte";
import Loading from "./Utils/Loading";

const Roles = React.lazy(() => import("./Utils/Roles"));
const Atributos = React.lazy(() => import("./Utils/Atributos"));
const FichaFinanzas = React.lazy(() => import("./Finanzas/FichaFinanzas"));
const BuscadorCohortes = React.lazy(() =>
  import("./Cohortes/BuscadorCohortes")
);
const DetallesCohorte = React.lazy(() => import("./Cohortes/DetallesCohorte"));
const PendientesCohortes = React.lazy(() =>
  import("./Cohortes/PendientesCohortes")
);
const CurriculumVitaePostulante = React.lazy(() =>
  import("./Postulaciones/CurriculumVitaePostulante")
);
const CrearCohorte = React.lazy(() => import("./Cohortes/CrearCohorte"));
const VidaCohortes = React.lazy(() => import("./Dashboard/VidaCohortes"));
const Ayuda = React.lazy(() => import("./Ayuda"));
const Postulaciones = React.lazy(() => import("./Postulaciones/Postulaciones"));
const PostulacionesTodas = React.lazy(() =>
  import("./Postulaciones/PostulacionesTodas")
);
const WallE = React.lazy(() => import("./Spa/WallE.jsx"));
const WallESence = React.lazy(() => import("./Spa/WallESence.jsx"));
const Cohortes = React.lazy(() => import("./Cohortes/Cohortes"));
const PanelGestionCalidad = React.lazy(() =>
  import("./sgc/PanelGestionCalidad")
);
const PanelPrograma = React.lazy(() => import("./sgc/PanelPrograma"));
const ReporteEncuestaFacultad = React.lazy(() =>
  import("./sgc/ReporteEncuestaFacultad")
);
const ReporteEncuestaPrograma = React.lazy(() =>
  import("./sgc/ReporteEncuestaPrograma")
);
const ReporteCompletitudEncuestas = React.lazy(() =>
  import("./sgc/ReporteCompletitudEncuestas")
);

const PagoProfesores = React.lazy(() => import("./UOL/PagoProfesores"));
const CalendarioPrograma = React.lazy(() =>
  import("./Calendario/CalendarioPrograma")
);
const Perfil = React.lazy(() => import("./Utils/Perfil"));
const Matriculas = React.lazy(() => import("./ReporteMatriculas/Matriculas"));
const Folleto = React.lazy(() => import("./Folleto/Folleto"));

const vistas = {
  "folleto-dinamico": {
    path: "/folleto-dinamico/:cohortid",
    content: (
      <Suspense fallback={<Loading />}>
        <Folleto />
      </Suspense>
    ),
    category: "Cohortes",
    subcategory: "Marketing",
    title: "Folleto",
    external: true,
    navbar: false,
    roles: [
      "Administrador",
      "Director Ejecutivo Postgrados",
      "Director de Ventas",
      "Coordinadora Admision",
      "Director de Programa",
      "Finanzas",
    ],
  },
  crearcohorte: {
    path: "/crearcohorte",
    category: "Cohortes",
    subcategory: "General",
    title: "Crear cohorte",
    external: true,
    navbar: true,
    content: (
      <Suspense fallback={<Loading />}>
        <CrearCohorte />
      </Suspense>
    ),
    fields: [],
    roles: ["Administrador", "Director Ejecutivo Postgrados"],
  },
  miscohortes: {
    path: "/miscohortes",
    category: "Ejecución",
    subcategory: "Coordinadora Programa",
    title: "Mis Cohortes",
    external: true,
    content: (
      <Suspense fallback={<Loading />}>
        <VidaCohortes />
      </Suspense>
    ),

    fieldsRequired: [
      "director_programa",
      "codirector_programa",
      "numero_sesiones",
      "dedicacionsem",
      "creditos_sct",
      "objetivo",
      "contenidos",
      "vacantes",
      "publicoobjetivo",
      "acreditacion",
      "niveldificultad",
      "coordinador_academico",
      "fecha_termino",
    ],
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Ventas",
      "Coordinadora Admision",
      "Coordinadora Académica",
    ],
  },
  "sgc-panel": {
    path: "/sgc-panel",
    content: (
      <Suspense fallback={<Loading />}>
        <PanelGestionCalidad />
      </Suspense>
    ),
    category: "Calidad",
    subcategory: "General",
    title: "Panel Gestión",
    external: true,
    navbar: true,
    fieldsRequired: ["programa_padre_id"],
    roles: [
      "Administrador",
      "Director Ejecutivo Postgrados",
      "Director de Programa",
      "Director de Ventas",
    ],
  },
  "sgc-completitud-encuestas": {
    path: "/sgc-completitud-encuestas",
    content: (
      <Suspense fallback={<Loading />}>
        <ReporteCompletitudEncuestas />
      </Suspense>
    ),
    fieldsRequired: [
      "encuesta_salida_programa",
      "encuesta_docente",
      "encuesta_admision_matricula",
      "encuesta_general_satisfaccion",
      "cohorte_padre_indicadores",
    ],
    category: "Calidad",
    subcategory: "Encuestas",
    title: "Completitud encuestas",
    external: true,
    navbar: true,
    roles: ["Administrador"],
  },
  "sgc-resumen": {
    category: "Calidad",
    subcategory: "Sistema de Gestión de Calidad",
    title: "Resumen programa",
    navbar: false,
    searchPlaceholder:
      "Buscar por fechas de inicio o término y unidad de venta forzada",
    fields: ["panel_sgc"],
    fieldsRequired: [
      "encuesta_salida_programa",
      "encuesta_docente",
      "sgc_comentarios",
      "datos_perfil_egreso",
      "incluir_panel_sgc",
      "cohorte_padre_indicadores",
      "informe_termino_programa",
    ],
    filtroCohortes: (coh) => {
      return (
        !coh.cohorte_padre_indicadores ||
        coh.cohorte_padre_indicadores === "0" ||
        coh.cohorte_padre_indicadores === 0
      );
    },
    roles: [
      "Administrador",
      "Director Ejecutivo Postgrados",
      "Director de Programa",
    ],
  },
  "sgc-encuestas": {
    path: "/sgc-encuestas",
    category: "Calidad",
    subcategory: "General",
    title: "Encuestas por programa",
    searchPlaceholder:
      "Buscar por fechas de inicio o término y unidad de venta forzada",
    fields: [
      "reporte_encuesta_inicio",
      "reporte_encuesta_salida",
      "reporte_encuesta_general_satisfaccion",
      "reporte_perfil_egreso",
    ],
    fieldsRequired: [
      "encuesta_inicio",
      "encuesta_salida_programa",
      "encuesta_general_satisfaccion",
      "encuesta_docente",
      "encuesta_admision",
    ],
    filtroCohortes: (cohorte) => {
      return (
        !cohorte.esborrador &&
        (!cohorte.cohorte_padre_indicadores ||
          cohorte.cohorte_padre_indicadores < 1)
      );
    },
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Ventas",
      "Director de Programa",
    ],
  },
  perfilegreso: {
    path: "/perfilegreso/:cohorteid",
    content: (
      <Suspense fallback={<Loading />}>
        <PerfilEgresoCohorte />
      </Suspense>
    ),
    category: "Calidad",
    subcategory: "Sistema de Gestión de Calidad",
    title: "Perfil de Egreso",
    external: true,
    navbar: false,
    roles: ["Administrador"],
  },
  walle: {
    path: "/walle",
    content: (
      <Suspense fallback={<Loading />}>
        <WallE />
      </Suspense>
    ),
    category: "Ejecución",
    subcategory: "SPA",
    title: "Carga académica (Wall-E)",
    external: true,
    navbar: true,
    roles: ["Administrador"],
    usuarios: [
      "andrea.pena",
      "valeska.saavedra",
      "maria.bezanilla",
      "francisca.palma",
      "andrea.calles",
      "mariangel.silva",
      "claudia.garabatos",
      "mariana.valle",
    ],
  },
  wallesence: {
    path: "/wallesence",
    content: (
      <Suspense fallback={<Loading />}>
        <WallESence />
      </Suspense>
    ),
    category: "Ejecución",
    subcategory: "SPA",
    title: "SENCE (Wall-E)",
    external: true,
    navbar: true,
    roles: ["Administrador"],
    usuarios: ["daniela.wilches", "rodrigo.ramirez"],
  },
  pagoprofesoresuol: {
    path: "/pagoprofesoresuol",
    content: (
      <Suspense fallback={<Loading />}>
        <PagoProfesores />
      </Suspense>
    ),
    category: "Reportes",
    subcategory: "UAI Online",
    title: "Pago profesores",
    external: true,
    navbar: true,
    fieldsRequired: [
      "ventas_por_periodo",
      "profesores_nucleo",
      "director_programa",
      "centrocosto",
    ],
    roles: ["Administrador","Pago Profesores (M.P.)"],
  },
  "sgc-panel-programa": {
    path: "/sgc-panel-programa/:programid",
    content: (
      <Suspense fallback={<Loading />}>
        <PanelPrograma />
      </Suspense>
    ),
    category: "Calidad",
    subcategory: "Sistema de Gestión de Calidad",
    title: "Panel Programa",
    external: true,
    navbar: false,
    fieldsRequired: [
      "EmailCoordinadorAdmision",
      "NombreCoordinadorAdmision",
      "TelefonoCoordinadorAdmision",
      "NombreCoordinadorAcademico",
      "NombreDirectorPrograma",
      "NombreCodirectorPrograma",
      "detalles_acreditacion",
      "profesores",
      "acreditacion",
      "fecha_decreto_creacion",
      "comite_academico_programa",
      "nucleo_programa",
      "ano_de_creacion",
      "fecha_de_vigencia",
      "sede_id",
      "campus",
      "LugarWeb",
      "programa_padre_id",
      "encuesta_salida_programa",
      "encuesta_docente",
      "cohorte_padre_indicadores",
    ],
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Ventas",
      "Director de Programa",
    ],
  },
  "sgc-datos-encuestas": {
    category: "Calidad",
    subcategory: "Datos",
    title: "Datos crudos encuestas",
    searchPlaceholder:
      "Buscar por fechas de inicio o término y unidad de venta forzada",
    fields: [
      "fecha_inicio",
      "fecha_termino",
      "cohorte_padre_indicadores",
      "encuesta_admision",
      "encuesta_inicio",
      "encuesta_docente",
      "encuesta_general_satisfaccion",
      "encuesta_salida_programa",
    ],
    filtroCohortes: (cohorte) => {
      return !cohorte.esborrador;
    },
    roles: ["Administrador"],
  },
  "sgc-encuesta": {
    path: "/sgc-encuesta/:encuesta/:cohortid",
    content: (
      <Suspense fallback={<Loading />}>
        <ReporteEncuestaPrograma />
      </Suspense>
    ),
    category: "Calidad",
    subcategory: "Encuestas",
    title: "Encuesta programa",
    external: true,
    navbar: false,
    fields: [
      "encuesta_inicio",
      "encuesta_salida_programa",
      "encuesta_general_satisfaccion",
      "encuesta_docente",
      "encuesta_admision",
    ],
    fieldsRequired: [
      "encuesta_inicio",
      "encuesta_salida_programa",
      "encuesta_general_satisfaccion",
      "encuesta_docente",
      "encuesta_admision",
    ],
    roles: [
      "Administrador",
      "Director Ejecutivo Postgrados",
      "Director de Programa",
      "Director de Ventas",
    ],
  },
  "sgc-encuesta-detalles": {
    path: "/sgc-encuesta-detalles",
    content: (
      <Suspense fallback={<Loading />}>
        <ReporteEncuestaFacultad />
      </Suspense>
    ),
    category: "Calidad",
    subcategory: "Encuestas",
    title: "Encuestas por Escuela-Facultad",
    external: true,
    navbar: true,
    fieldsRequired: [
      "NombreCoordinadorAcademico",
      "NombreDirectorPrograma",
      "encuesta_salida_programa",
      "encuesta_docente",
      "encuesta_inicio",
      "encuesta_general_satisfaccion",
      "encuesta_admision",
    ],
    roles: [
      "Administrador",
      "Director Ejecutivo Postgrados",
      "Director de Programa",
      "Director de Ventas",
    ],
  },
  "detalles-borrador": {
    path: "/borrador/:cohortid",
    content: (
      <Suspense fallback={<Loading />}>
        <DetallesCohorte borrador={true} view={"detalles-cohorte"} />
      </Suspense>
    ),
    category: "Cohortes",
    subcategory: "General",
    title: "Detalles cohorte borrador",
    external: true,
    navbar: false,
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Ventas",
      "Coordinadora Admision",
      "Finanzas",
    ],
  },

  "detalles-cohorte": {
    path: "/cohorte/:cohortid",
    content: (
      <Suspense fallback={<Loading />}>
        <DetallesCohorte view={"detalles-cohorte"} />
      </Suspense>
    ),
    category: "Cohortes",
    subcategory: "General",
    title: "Detalles cohorte",
    external: true,
    navbar: false,
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Ventas",
      "Coordinadora Admision",
      "Coordinadora Académica",
      "Finanzas",
    ],
  },
  postulaciones: {
    path: "/postulaciones",
    content: (
      <Suspense fallback={<Loading />}>
        <PostulacionesTodas todos={true} titulo={"Mis postulaciones"} />
      </Suspense>
    ),
    category: "Postulaciones",
    subcategory: "Buscar",
    title: "Mis postulaciones",
    external: true,
    fieldsRequired: ["documentos_requeridos"],
    roles: [
      "Administrador",
      "Director Ejecutivo Postgrados",
      "Director de Programa",
      "Director de Ventas",
      "Coordinadora Admision",
    ],
  },
  entrevistas: {
    path: "/entrevistas",
    category: "Postulaciones",
    subcategory: "Buscar",
    title: "Mis entrevistas",
    external: true,
    content: (
      <Suspense fallback={<Loading />}>
        <PostulacionesTodas
          todos={true}
          entrevistas={true}
          columnas={[
            "PostulacionId",
            "GradoNombre",
            "CohorteNombre",
            "FechaPostulacion",
            "PostulanteNombre",
            "PaisResidencia",
            "NumeroDocumento",
            "EstadoNombre",
          ]}
          año={true}
          titulo="Entrevistas pendientes"
        />
      </Suspense>
    ),
    fieldsRequired: [],
    roles: [
      "Director de Programa",
      "Director de Ventas",
      "Coordinadora Admision",
    ],
  },
  "postulaciones-cohorte": {
    path: "/postulaciones-cohorte",
    content: (
      <Suspense fallback={<Loading />}>
        <Postulaciones />
      </Suspense>
    ),
    category: "Postulaciones",
    subcategory: "Buscar",
    title: "Por cohorte",
    external: true,
    fieldsRequired: ["sigla"],
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Programa",
      "Director de Ventas",
      "Coordinadora Admision",
    ],
  },
  postulacion: {
    path: "/postulacion/:cohorteid/:postulacionid",
    content: (
      <Suspense fallback={<Loading />}>
        <CurriculumVitaePostulante />
      </Suspense>
    ),
    category: "Postulaciones",
    subcategory: "Buscar",
    title: "Por cohorte",
    external: true,
    fieldsRequired: ["sigla"],
    navbar: false,
    roles: ["*"],
  },
  "documentos-postulaciones-cohorte": {
    path: "/documentos-postulaciones/:cohorte",
    content: (
      <Suspense fallback={<Loading />}>
        <Postulaciones documentos={true} />
      </Suspense>
    ),
    category: "Postulaciones",
    subcategory: "Buscar",
    title: "Documentos",
    navbar: false,
    external: true,
    fieldsRequired: ["documentos_requeridos"],
    roles: [
      "Director de Programa",
      "Director de Ventas",
      "Coordinadora Admision",
      "Coordinadora Académica",
    ],
  },
  "documentos-postulaciones": {
    path: "/documentos-postulaciones",
    content: (
      <Suspense fallback={<Loading />}>
        <Postulaciones documentos={true} />
      </Suspense>
    ),
    category: "Postulaciones",
    subcategory: "Buscar",
    title: "Documentos",
    navbar: true,
    external: true,
    fieldsRequired: ["documentos_requeridos"],
    roles: [
      "Director de Programa",
      "Director de Ventas",
      "Coordinadora Admision",
      "Coordinadora Académica",
    ],
  },
  reportematriculas: {
    path: "/reportematriculas",
    content: (
      <Suspense fallback={<Loading />}>
        <Matriculas title={"Postulantes y Matriculados"} />
      </Suspense>
    ),
    category: "Reportes",
    subcategory: "Matrículas",
    title: "Postulantes y Matriculados",
    external: true,
    fields: [
      "gradoid",
      "sigla",
      "habilitado",
      "fecha_inicio",
      "fecha_termino",
      "duracion",
      "campus",
      "sede_id",
      "horario_clases",
      "nombrecorto",
      "metas_mensuales",
      "datos_salesforce",
      "google_analytics_data",
      "grupo_reporte_matriculados",
      "programaid_anterior",
      "meta",
      "metas_mensuales",
      "documentos_requeridos",
      "disponibilidad",
      "centrocosto",
    ],
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Programa",
      "Director de Ventas",
      "Coordinadora Admision",
      "Coordinadora Académica",
      "Marketing",
    ],
  },
  fichafinanzas: {
    category: "Cohortes",
    subcategory: "Finanzas",
    title: "Ficha Financiera",
    external: true,
    navbar: false,
    fields: ["centrocosto"],
    roles: ["Finanzas"],
    path: "/fichafinanzas/:cohorteid",
    content: (
      <Suspense fallback={<Loading />}>
        <FichaFinanzas view={"fichafinanzas"} />
      </Suspense>
    ),
  },
  calendarioprograma: {
    category: "Cohortes",
    subcategory: "General",
    title: "Calendario sesiones",
    external: true,
    navbar: false,
    roles: ["Director Ejecutivo Postgrados", "Director Ventas"],
    path: "/calendario/:cohorteid",
    fields: ["fecha_inicio", "fecha_termino", "calendario"],
    content: (
      <Suspense fallback={<Loading />}>
        <CalendarioPrograma view={"calendarioprograma"} />
      </Suspense>
    ),
  },
  perfil: {
    path: "/perfil",
    content: (
      <Suspense fallback={<Loading />}>
        <Perfil />
      </Suspense>
    ),
    category: "Configuración",
    subcategory: "Maestro Productos",
    title: "Perfil",
    external: true,
    roles: ["*"],
  },
  atributos: {
    path: "/atributos",
    content: (
      <Suspense fallback={<Loading />}>
        <Atributos />
      </Suspense>
    ),
    category: "Configuración",
    subcategory: "Maestro Productos",
    title: "Atributos",
    external: true,
    roles: ["Administrador"],
  },
  roles: {
    path: "/roles",
    content: (
      <Suspense fallback={<Loading />}>
        <Roles />
      </Suspense>
    ),
    category: "Configuración",
    subcategory: "Maestro Productos",
    title: "Roles",
    external: true,
    roles: ["Administrador"],
  },
  ayuda: {
    path: "/ayuda",
    content: (
      <Suspense fallback={<Loading />}>
        <Ayuda />
      </Suspense>
    ),
    navbar: false,
    external: true,
    category: "Maestro de Programas",
    subcategory: "Ayuda",
    title: "Tutoriales",
    roles: ["*"],
  },
  "info-general": {
    category: "Cohortes",
    subcategory: "General",
    title: "Fechas",
    searchPlaceholder: "Buscar por nombre, sigla, horario o sede",
    fields: [
      "gradoid",
      "sigla",
      "habilitado",
      "fecha_inicio",
      "fecha_termino",
      "duracion",
      "campus",
      "sede_id",
      "horario_clases",
    ],
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Programa",
      "Director de Ventas",
      "Coordinadora Admision",
      "Finanzas",
      "Coordinadora Académica",
    ],
  },
  "direccion-ventas": {
    category: "Cohortes",
    subcategory: "Comercial",
    title: "Dirección de ventas",
    searchPlaceholder: "Buscar por Director o Codirector de Programa",
    fields: [
      "director_programa",
      "codirector_programa",
      "precio",
      "habilitado",
      "sede_id",
    ],
    roles: ["Director de Ventas"],
  },
  "info-academica": {
    category: "Cohortes",
    subcategory: "General",
    title: "Académica",
    searchPlaceholder:
      "Buscar por directores de programa, objetivos, contenidos...",
    fields: [
      "director_programa",
      "codirector_programa",
      "numero_sesiones",
      "dedicacionsem",
      "creditos_sct",
      "facultades_secundarias",
      "objetivo",
      "contenidos",
      "vacantes",
      "publicoobjetivo",
      "acreditacion",
      "niveldificultad",
      "coordinador_academico",
    ],
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Programa",
      "Director de Ventas",
      "Coordinadora Admision",
      "Coordinadora Académica",
    ],
  },
  calendarios: {
    category: "Cohortes",
    subcategory: "General",
    title: "Calendario sesiones",
    external: false,
    roles: ["Director Ejecutivo Postgrados", "Director Ventas"],
    fields: [
      "fecha_inicio",
      "fecha_termino",
      "calendario",
      "calendario_detallado",
    ],
    path: "/calendario",
  },
  holmes: {
    category: "Cohortes",
    subcategory: "General",
    title: "Holmes",
    searchPlaceholder: "Buscar por nombre, sigla, horario o sede",
    navbar: true,
    fields: [
      "gradoid",
      "sigla",
      "habilitado",
      "disponibilidad",
      "centrocosto",
      "tprpro",
      "sprpro",
      "codpro",
      "precio",
      "meta",
      "fecha_inicio",
      "coordinador_academico",
      "usuario_coordinador_admision",
    ],
    roles: ["Director de Ventas"],
  },
  uol: {
    category: "Cohortes",
    subcategory: "General",
    title: "UAI Online",
    searchPlaceholder: "",
    navbar: true,
    fields: [
      "habilitado",
      "disponibilidad",
      "featured",
      "trending",
      "recently_added",
      "soon",
      "area_tematica_catalogo",
      "BajadaTitulo",
      "formulariov2",
      "centrocosto",
      "tprpro",
      "sprpro",
      "codpro",
      "precio",
    ],
    roles: ["Director Ejecutivo Postgrados", "Director de Ventas"],
  },
  otec: {
    category: "Cohortes",
    subcategory: "General",
    title: "OTEC",
    searchPlaceholder: "",
    navbar: true,
    fields: [
      "nombre_sence",
      "fecha_vigencia_sence",
      "observaciones_sence",
      "fecha_ingreso_sence",
      "codigo_sence",
      "valorefparticipante",
      "horaspracticas",
      "horasteoricas",
      "horaselearning",
      "valorimpparticipante",
      "profesores_nucleo",
    ],
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Ventas",
      "Coordinadora Admision",
      "Coordinadora Académica",
      "OTEC",
    ],
  },
  nucleos: {
    category: "Calidad",
    subcategory: "Datos",
    title: "Núcleos y comités académicos",
    fields: ["nombre", "nucleo_programa", "comite_academico_programa"],
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Programa",
      "Director de Ventas",
    ],
  },
  decretos: {
    category: "Calidad",
    subcategory: "Datos",
    title: "Decretos de Creación",
    searchPlaceholder: "Buscar por nombre o sigla",
    fields: [
      "nombre",
      "habilitado",
      "gradoid",
      "sigla",
      "codigo_decreto",
      "fecha_decreto_creacion",
    ],
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Programa",
      "Director de Ventas",
    ],
  },
  precio: {
    category: "Cohortes",
    subcategory: "Comercial",
    title: "Precio",
    searchPlaceholder: "Buscar por arancel, matrícula, descuentos...",
    fields: [
      "precio",
      "precio_postulacion",
      "mediosdepago",
      "descuentos",
      "descuentos_disponibles",
    ],
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Ventas",
      "Coordinadora Admision",
    ],
  },
  ventas: {
    category: "Cohortes",
    subcategory: "Comercial",
    title: "Ventas",
    searchPlaceholder: "Buscar por precio, metas o coordinadora de admisión",
    fields: [
      "sigla_interna",
      "fecha_inicio",
      "metas_mensuales",
      "meta",
      "precio",
      "meta_plata",
      "usuario_coordinador_admision",
      "razon_no_se_dicto",
      "dictado",
    ],
    roles: ["Director de Ventas", "Coordinadora Admision"],
  },
  "formulario-postula": {
    category: "Cohortes",
    subcategory: "Comercial",
    title: "Formulario Postula",
    searchPlaceholder: "Buscar por texto del preformulario",
    fields: [
      "disponibilidad",
      "preformulario_habilitado",
      "preformulario_texto",
    ],
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Ventas",
      "Marketing",
      "Coordinadora Admision",
    ],
  },
  procesoadmision: {
    category: "Cohortes",
    subcategory: "Comercial",
    title: "Proceso de admisión",
    searchPlaceholder:
      "Buscar por proceso de admisión, pre-requisitos o etapas",
    fields: [
      "proceso_admision",
      "prerequisitos",
      "etapas_antecedentes",
      "etapas_entrevistas_examenes",
      "etapas_matricula",
      "documentos_requeridos",
    ],
    roles: ["Director de Ventas", "Marketing", "Coordinadora Admision"],
  },
  "coordinadora-admision": {
    category: "Cohortes",
    subcategory: "Comercial",
    title: "Coordinadora Admisión",
    searchPlaceholder:
      "Buscar por coordinadora de admisión, nombre corto, precio o Director de Programa",
    fields: [
      "usuario_coordinador_admision",
      "director_programa",
      "precio",
      "habilitado",
      "programaid_anterior",
      "fecha_inicio",
      "nombrecorto",
    ],
    roles: ["Director de Ventas", "Coordinadora Admision"],
  },
  profesores: {
    category: "Cohortes",
    subcategory: "Académica",
    title: "Profesores",
    fields: [
      "facultades_secundarias",
      "profesores_nucleo",
      "director_programa",
    ],
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Ventas",
      "Coordinadora Admision",
    ],
  },
  pagoprofesores: {
    category: "Cohortes",
    subcategory: "Admisión",
    title: "Pago profesores",
    fields: [
      "ventas_por_periodo",
      "profesores_nucleo",
      "director_programa",
      "ventas_por_periodo_raw",
    ],
    roles: ["Administrador"],
  },
  "reporte-matriculas": {
    category: "Reportes",
    subcategory: "Matrículas",
    title: "Configuración reporte",
    searchPlaceholder:
      "Buscar por fechas de inicio o término y unidad de venta forzada",
    fields: [
      "grupo_reporte_matriculados",
      "programaid_anterior",
      "habilitado",
      "dictado",
      "unidadventa",
    ],
    roles: ["Director de Ventas", "Coordinadora Admision", "Marketing"],
  },
  marketing: {
    category: "Cohortes",
    subcategory: "Marketing",
    title: "Configuración web",
    searchPlaceholder:
      "Buscar por nombre corto, áreas temática o académica, o URL del folleto",
    fields: [
      "habilitado",
      "disponibilidad",
      "nombrecorto",
      "area_tematica_multiple",
      "area_academica",
      "imagen",
      "Folleto",
    ],
    roles: ["Director Ejecutivo Postgrados", "Director de Ventas", "Marketing"],
  },
  web: {
    category: "Cohortes",
    subcategory: "Marketing",
    title: "Página web",
    searchPlaceholder: "Buscar por todos los atributos usados en la web",
    fields: [
      "gradoid",
      "habilitado",
      "fecha_inicio",
      "area_tematica",
      "BajadaTitulo",
      "objetivo",
      "publicoobjetivo",
      "prerequisitos",
      "dedicacionsem",
      "sede_id",
      "LugarWeb",
      "proceso_admision",
      "EtapasPostulacion",
      "etapas_antecedentes",
      "etapas_entrevistas_examenes",
      "etapas_matricula",
      "idioma",
      "imagen",
      "ImagenVideo",
      "niveldificultad",
      "precio",
      "descuentos",
      "videoprom",
      "TemplateWeb",
    ],
    roles: ["Director Ejecutivo Postgrados", "Director de Ventas", "Marketing"],
  },
  "respuesta-becas": {
    category: "Cohortes",
    subcategory: "Comercial",
    title: "Respuestas automáticas becas",
    fields: [
      "nombre",
      "fecha_inicio",
      "fecha_termino",
      "horario_clases",
      "objetivo",
      "prerequisitos",
      "documentos_requeridos",
    ],
    roles: ["Director Ejecutivo Postgrados", "Director de Ventas", "Marketing"],
  },
  folleto: {
    category: "Cohortes",
    subcategory: "Marketing",
    title: "Folleto",
    searchPlaceholder: "Buscar por todos los atributos usados en el folleto",
    fields: [
      "nombre",
      "objetivo",
      "publicoobjetivo",
      "objetivos_especificos",
      "contenidos_detallados",
      "usuario_coordinador_admision",
      "folleto_automatico",
    ],
    roles: ["Director Ejecutivo Postgrados", "Director de Ventas", "Marketing"],
  },
  respuestasautomaticas: {
    category: "Cohortes",
    subcategory: "Marketing",
    title: "Respuestas automáticas",
    searchPlaceholder:
      "Buscar por fecha de inicio, horario de clases, precio o sede",
    fields: [
      "habilitado",
      "fecha_inicio",
      "horario_clases",
      "precio",
      "sede_id",
      "formulario_contacto",
    ],
    roles: ["Director Ejecutivo Postgrados", "Director de Ventas", "Marketing"],
  },
  finanzas: {
    category: "Cohortes",
    subcategory: "Finanzas",
    title: "Centro de Costo y Códigos AS400",
    searchPlaceholder: "Buscar por centro de costo o código AS400",
    minquery: 1,
    fields: ["centrocosto", "tprpro", "sprpro", "codpro", "fichafinanciera"],
    roles: ["Director Ejecutivo Postgrados", "Director de Ventas", "Finanzas"],
    excluir: {
      grados: [8],
    },
  },
  "fichafinanciera-cohorte": {
    category: "Cohortes",
    subcategory: "Finanzas",
    title: "Ficha financiera",
    searchPlaceholder: "",
    fields: [
      "solicitud_centrocosto",
      "centrocosto",
      "subarea",
      "tprpro",
      "sprpro",
      "codpro",
      "Vencimientos",
      "devengos",
      "cuenta",
      "item",
    ],
    navbar: false,
    roles: ["Director Ejecutivo Postgrados", "Director de Ventas", "Finanzas"],
    excluir: {
      grados: [8],
    },
  },
  home: {
    category: "Cohortes",
    title: "Mis cohortes",
    searchPlaceholder: "Buscar por nombre, sigla, horario o sede",
    navbar: false,
    roles: [
      "Director Ejecutivo Postgrados",
      "Director de Programa",
      "Director de Ventas",
      "Coordinadora Admision",
      "Finanzas",
    ],
  },
};

export default vistas;
